import { createFileRoute } from '@tanstack/react-router';

import { orpc } from '@/lib/api/orpc';
import { queryClient } from '@/lib/queryClient';

import { getMfaSettings } from './-query/api';
import { getSsoConnections, getSsoProviders } from './-sso-query/api';

export const Route = createFileRoute(
  '/_staff/settings/persons/_list/settings/',
)({
  loader: async () => {
    await Promise.all([
      getMfaSettings(),
      getSsoProviders(),
      getSsoConnections(),
      queryClient.ensureQueryData(
        orpc.loginEmailPolicy.getOrgPolicies.queryOptions({ input: {} }),
      ),
    ]);
  },
});
